import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  FaUsers,
  FaFileInvoice,
  FaMoneyBillWave,
  FaTasks,
  FaIndustry, 
  FaWeight,
} from "react-icons/fa";
import "./dash.css";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.5 },
  }),
};

const DashboardHome = () => {
  const [data, setData] = useState({
    farmers: 0,
    employee: 0,
    todaytea: 0,
    todayfactory: 0,
    yestea: 0,
    yesfactory: 0,
    factory:0,
    tare:0,
  });

  useEffect(() => {
    const fetchData = async () => {
      const endpoints = [
        { key: "farmers", url: "https://kmtea.onrender.com/count/farmers", field: "count" },
        { key: "employee", url: "https://kmtea.onrender.com/count/employee", field: "count" },
        { key: "todaytea", url: "https://kmtea.onrender.com/count/tea", field: "total" },
        { key: "todayfactory", url: "https://kmtea.onrender.com/count/factory", field: "total" },
        { key: "yestea", url: "https://kmtea.onrender.com/count/yesterdaytea", field: "total" },
        { key: "yesfactory", url: "https://kmtea.onrender.com/count/yesterdayfactory", field: "total" },
            { key: "factory", url: "https://kmtea.onrender.com/count/fact", field: "total" },
              { key: "tare", url: "https://kmtea.onrender.com/count/tare", field: "total" },
      ];

      const newData = {};
      for (const endpoint of endpoints) {
        try {
          const res = await fetch(endpoint.url);
          const result = await res.json();
          newData[endpoint.key] = result[endpoint.field] || 0;
        } catch (err) {
          console.error(`Error fetching ${endpoint.key}:`, err);
          newData[endpoint.key] = 0;
        }
      }
      setData(newData);
    };

    fetchData();
  }, []);

  const cards = [
    { title: "Farmers", icon: <FaUsers />, value: data.farmers },
    { title: "Employees", icon: <FaUsers />, value: data.employee },
    { title: "Today's Collection", icon: <FaMoneyBillWave />, value: `${data.todaytea} Kg` },
    { title: "Today's Factory", icon: <FaTasks />, value: `${data.todayfactory} Kg` },
    { title: "Yesterday's Collection", icon: <FaMoneyBillWave />, value: `${data.yestea} Kg` },
    { title: "Yesterday's Factory", icon: <FaTasks />, value: `${data.yesfactory} Kg` },
    { title: "Factories", icon: <FaIndustry />, value: data.factory },
{ title: "Total tare", icon: <FaWeight />, value: `${data.tare} Kg` },
  ];

  return (
    <div className="dashboard-container">
      {cards.map((card, i) => (
        <motion.div
          className="card"
          key={card.title}
          custom={i}
          initial="hidden"
          animate="visible"
          variants={cardVariants}
        >
          <div className="icon">{card.icon}</div>
          <div className="title">{card.title}</div>
          <div className="value">{card.value}</div>
        </motion.div>
      ))}
    </div>
  );
};

export default DashboardHome;
